import { DomainFault, type DomainModule } from '../contracts';
import type { Role } from '../types';

const roles: Role[] = ['groupOperator', 'campusManager', 'regionManager'];
const need = (text: string | undefined, name: string) => {
  if (!text?.trim()) throw new DomainFault('VALIDATION', `请填写${name}`);
  return text.trim();
};
export const administrationDomain: DomainModule = {
  namespace: 'administration',
  version: 1,
  resource: 'organization',
  migrations: [
    {
      version: 1,
      up(state) {
        state.domainData ||= {};
        state.domainData.administration ||= {};
      },
    },
  ],
  commands: {
    createMember: {
      roles,
      kind: 'teacher',
      label: '新增业务演示人员',
      execute(ctx, input) {
        const campus = ctx
          .list('organization')
          .find(
            (o) =>
              o.uuid === input.fields?.organizationUuid &&
              o.fields?.type === '校区' &&
              o.status === 'active',
          );
        if (!campus)
          throw new DomainFault('VALIDATION', '请选择授权范围的有效校区');
        const name = need(input.title, '人员姓名');
        const row = ctx.append('teacher', name, {
          campus: campus.campus,
          memberUuid: crypto.randomUUID(),
          status: 'active',
          note: need(input.note, '人员资料依据'),
          fields: {
            subject: input.fields?.subject || '待补充',
            businessOnly: 'true',
          },
        });
        return row;
      },
    },
    moveMember: {
      roles,
      kind: 'teacher',
      label: '调整业务人员所属校区',
      execute(ctx, input) {
        const row = ctx.get(input.uuid);
        const campus = ctx
          .list('organization')
          .find(
            (o) =>
              o.uuid === input.fields?.organizationUuid &&
              o.fields?.type === '校区' &&
              o.status === 'active',
          );
        if (row?.kind !== 'teacher' || !campus)
          throw new DomainFault('FORBIDDEN', '人员或目标校区不可访问');
        if (row.campus === campus.campus)
          throw new DomainFault('VALIDATION', '目标校区与当前相同');
        const activeBindings = ctx
          .list('binding')
          .filter((b) => b.memberUuid === row.memberUuid && !b.endAt);
        const unfinished = ['task', 'case', 'plan', 'followUp'] as const;
        if (
          activeBindings.length ||
          unfinished.some((kind) =>
            ctx
              .list(kind)
              .some(
                (e) =>
                  (e.owner === row.memberUuid ||
                    e.memberUuid === row.memberUuid) &&
                  !['completed', 'closed', 'cancelled', 'excluded'].includes(
                    e.status,
                  ),
              ),
          )
        )
          throw new DomainFault(
            'INVALID_TRANSITION',
            '请先归还设备并完成或转派未结工作',
          );
        row.note = need(input.note, '调动依据');
        row.fields = {
          ...row.fields,
          previousCampus: row.campus,
          movedAt: ctx.now,
        };
        row.campus = campus.campus;
        ctx.touch(row);
        return row;
      },
    },
  },
};
